import React from "react";

import { Helmet, HelmetProvider } from 'react-helmet-async'

// ゲットナビゲータ
import Header from "../components/Header";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ScrollToTop from "../ScrollToTop";

// スタイルインポート
import "../pages/css/packages.scss";
import "../responsive/PackageResponsive.scss";
import "../common.scss";

// メインビジュアル
import headerSubImg from "../img/packages/package-img.webp";

//アイコン
import arrowRight from "../img/packages/arrow-right.svg";

// framer motion
import { motion } from "framer-motion";

function Packages() {
  return (
    <motion.div 
    className="packages"
    initial={{ width: 0 }}
    animate={{ width: "100%" }}
    exit={{ x: window.innerWidth, transition: { duration: 0.1 } }}
    >
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#005bac" />
        <meta
          name="keywords"
          content="千葉県千葉市web制作,千葉市格安ホームページ制作,千葉市web集客,smartgenz,パドリナアレン,smartgenzとは？"
        />
        <meta
          name="description"
          content="ユーザーの気持ちを汲み取った効果的なブランディングと集客導線づくりを取り入れて、お客様の理想なデザインと自然と人が集まるものを制作します。"
        />
        <meta property="og:title" content="千葉県千葉市でのホームページ制作ならSmartGenz | パッケージについて" />
        <meta
          property="og:description"
          content="ユーザーの気持ちを汲み取った効果的なブランディングと集客導線づくりを取り入れて、お客様の理想なデザインと自然と人が集まるものを制作します。"
        />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://smartgenz.com/packages" />
        <meta property="og:site_name" content="千葉県千葉市でのホームページ制作ならSmartGenz | パッケージについて" />
        <meta property="og:locale" content="ja_JP" />
        <link rel="canonical" href="https://smartgenz.com/packages" />
        <title>千葉県千葉市でのホームページ制作ならSmartGenz | パッケージについて</title>
        </Helmet>
		  </HelmetProvider>
      <Header />
      <article className="sub-image">
        <div className="sub-main-image position-about">
          <img
            src={headerSubImg}
            alt="アイテム　｜ ヘッダーイメージ"
          ></img>
        </div>
      </article>
      <section className="pkg-sec">
        <div className="sub-sec-company-ttl">
          <div className="borderA"></div>
          <h2 data-desc="パッケージ">PACKAGES</h2>
          <div className="borderB"></div>
        </div>
        <h3>WEBサイト制作・ホームページ制作</h3>
        <div className="pkg-sec-mission">
          いつの時代もWEBサイトは作り手のものではなく、ご依頼いただくお客様のものです。
          <br className="pcOnly" />
          デザインやWEB制作、ITの専門家として、お客様に今必要なカタチを企画・製作いたします。
        </div>
      </section>
      <section className="pkg-boxes">
        <div className="pkg-box01 box">
          <div className="ttl">シングルページ制作</div>
          <div className="fee">50,000円</div>
          <div className="target">個人事業主向け</div>
          <div className="sub-ttl">パッケージ概要</div>
          <ul className="pkg-about">
            <li>ドメインセットアップ（任意）</li>
            <li>無料SSL証明書（任意）</li>
            <li>簡易SEO対策（内部SEO）</li>
            <li>スマートフォン対策</li>
            <li>テンプレートデザイン</li>
            <li>シングルページ</li>
            <li>お問い合わせ </li>
            <li>Google Map掲載</li>
          </ul>
        </div>
        <div className="pkg-box02 box">
          <div className="ttl">ライトプラン</div>
          <div className="fee">200,000円</div>
          <div className="target">小規模事業者</div>
          <div className="sub-ttl">パッケージ概要</div>
          <ul className="pkg-about">
            <li>ドメインセットアップ（任意）</li>
            <li>無料SSL証明書（任意）</li>
            <li>簡易SEO対策（内部SEO）</li>
            <li>スマートフォン対策</li>
            <li>オリジナルデザイン</li>
            <li>TOPページ＋下層1ページ</li>
            <li>お問い合わせページ（フォーム付き） </li>
            <li>Google Map掲載</li>
          </ul>
        </div>
        <div className="pkg-box03 box">
          <div className="ttl">スタンダードプラン</div>
          <div className="fee">300,000円</div>
          <div className="target">小規模事業者（上位版）</div>
          <div className="sub-ttl">パッケージ概要</div>
          <ul className="pkg-about">
            <li>ドメインセットアップ（任意）</li>
            <li>無料SSL証明書（任意）</li>
            <li>簡易SEO対策（内部SEO）</li>
            <li>スマートフォン対策（Google対策） </li>
            <li>オリジナルデザイン（高品質）</li>
            <li>TOPページ＋下層2ページ（集客対策）</li>
            <li>お問い合わせページ（フォーム付き） </li>
            <li>Google Map掲載</li>
            <li>CMS導入（更新機能）</li>
            <li>簡易アクセス解析</li>
            <li>SNS連動設定</li>
          </ul>
        </div>
      </section>
      <div className="important_point">
        <ul className="important-list">
          <li>金額はすべて税別です。</li>
          <li>注意事項を読んでからご依頼ください。</li>
          <li>お客様のご要望により費用が変動する場合がございます。</li>
        </ul>
        {/* <section className="important-button">
          <div className="btn to-project-request">
            <span>ご依頼方法はこちら</span>
            <img src={arrowRight} alt="" />
          </div>
          <div className="btn to-important-request">
            <span>制作に関する注意事項</span>
            <img src={arrowRight} alt="" />
          </div>
        </section> */}
      </div>
      <Contact />
      <Footer />
    </motion.div>
  );
}

export default Packages;
